import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config} from '../../shared';
import { ReturnSalesInvoiceDtoModel } from '../../../data-transfer-objects';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReturnSalesOrderService extends BaseApiTemplateService<ReturnSalesInvoiceDtoModel[]> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'previous-returns/return-by-document/internal-packing-orders';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'previous-returns/return-by-document/internal-packing-orders';
    this.httpClient = http;
  }

  public getSalesOrders(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<ReturnSalesInvoiceDtoModel>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl,
      dtoObject,
      this.getHttpHeader(visa)
    );
  }


}
